export const messages = {
  en: {
    initializeCommunityManage: {
      queryCondition: 'Query Conditions',
      inputCommunityId: 'Please enter community ID',
      inputCommunityName: 'Please enter community name',
      query: 'Query',
      reset: 'Reset',
      initializeCommunityData: 'Initialize Community Data',
      communityId: 'Community ID',
      communityName: 'Community Name',
      nearbyLandmark: 'Nearby Landmark',
      cityCode: 'City Code',
      status: 'Status',
      operation: 'Operation',
      format: 'Format'
    },
    chooseinitializeCommunity: {
      warmPrompt: 'Warm Prompt',
      operateCarefully: 'Please operate carefully',
      warningMessage: 'This operation will clear all data of community [{communityName}], community ID is [{communityId}]. Please confirm again with relevant personnel!',
      inputDevPassword: 'Please enter developer password',
      wrongClick: 'Wrong Click',
      confirmFormat: 'Confirm Format'
    }
  },
  zh: {
    initializeCommunityManage: {
      queryCondition: '查询条件',
      inputCommunityId: '请输入小区ID',
      inputCommunityName: '请输入小区名称',
      query: '查询',
      reset: '重置',
      initializeCommunityData: '初始化小区数据',
      communityId: '小区ID',
      communityName: '小区名称',
      nearbyLandmark: '附近地标',
      cityCode: '城市编码',
      status: '状态',
      operation: '操作',
      format: '格式化'
    },
    chooseinitializeCommunity: {
      warmPrompt: '温馨提示',
      operateCarefully: '请慎重操作',
      warningMessage: '此操作将清空所有【{communityName}】小区数据,小区编码为【{communityId}】。谨慎期间，请再次跟相关人员核实确认！',
      inputDevPassword: '请输入开发者密码',
      wrongClick: '点错了',
      confirmFormat: '确认格式化'
    }
  }
}